import React from 'react';
import PropTypes from 'prop-types';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/styles';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import Box from '@material-ui/core/Box';

import CloseButton from 'bento-ordering/base/ui_components/CloseButton';
import { FONT_NAMES } from 'bento-ordering/base/theme/font';

const styles = theme => ({
  root: {
    '& .MuiTypography-h6': {
      fontFamily: FONT_NAMES.med
    }
  },
  paper: {
    [theme.breakpoints.down('md')]: {
      width: '90%',
      marginLeft: 0,
      marginRight: 0
    }
  }
});
class NotificationModal extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    body: PropTypes.string,
    classes: PropTypes.shape({})
  };

  render() {
    const Children = React.Children.toArray(this.props.children);
    return (
      <Dialog
        open
        onClose={this.props.onClose}
        maxWidth="xs"
        classes={this.props.classes}
      >
        <Box pt={1.5} pl={2.5} pr={2.5} pb={1.25}>
          <CloseButton autoFocus handleClick={this.props.onClose} />
          <DialogTitle>{this.props.title}</DialogTitle>
        </Box>
        {(this.props.body || !!Children.length) && (
          <DialogContent>
            {this.props.body && (
              <DialogContentText>{this.props.body}</DialogContentText>
            )}
            {!!Children.length && (
              <DialogActions disableSpacing>{Children}</DialogActions>
            )}
          </DialogContent>
        )}
      </Dialog>
    );
  }
}

export default withStyles(styles)(NotificationModal);
